import { render, staticRenderFns } from "./IncorporationDetails.vue?vue&type=template&id=184b9240&scoped=true"
import script from "./IncorporationDetails.vue?vue&type=script&lang=js"
export * from "./IncorporationDetails.vue?vue&type=script&lang=js"
import style0 from "./IncorporationDetails.vue?vue&type=style&index=0&id=184b9240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b9240",
  null
  
)

export default component.exports